import styled from 'styled-components';
import { Space, Text, ModalContent, Paper } from '@cashfree-intl/coherent';

export const StyledBankDetailsSpace = styled(Space)`
  background-color: #f9f5ff;
`;

export const StyledWalletActivationWarningText = styled(Text)`
  backgroundcolor: rgba(214, 131, 9, 0.12);
  border-radius: 2px;
  width: fit-content;
  padding: 2px 0;
`;

export const StyledRechargeProgressModal = styled(ModalContent)`
  padding: 2rem !important;
`;

export const StyledWalletCardDivision = styled.div`
  background-color: #e6e5e8;
  height: 1px;
`;

export const StyledWalletCardPaper = styled(Paper)`
  width: 31.25rem;
`;

export const WalletIntroCardsPaper = styled(Paper)`
  width: fit-content;
  text-align: center;
`;

export const StyledRefreshText = styled(Text)`
  cursor: pointer;
`;

export const StyledList = styled.div`
  border-radius: 2px;
  background-color: rgba(214, 131, 9, 0.12);
`;

export const StyledBannerCard = styled(Space)`
  align-items: center;
  text-align: center;
  gap: 0.625rem;
  width: 13.75rem;
`;

export const StyledFeeWalletLowBalanceSpace = styled(Space)`
  background-color: #f7dfdf;
  padding: 2px 6px;
  border-radius: 2px;
`;
